import { Chip } from "@braintrust/braintrust-ui-components";
import type { Skill } from "@js/types/admin";

type SelectableSkillItemProps = {
  skill: Pick<Skill, "id" | "name">;
  selected?: boolean;
  handleClick: (skillId: number) => void;
};

export const SelectableSkillItem = ({
  skill,
  handleClick,
  selected,
}: SelectableSkillItemProps) => {
  return (
    <Chip
      role="checkbox"
      onClick={() => handleClick(skill.id)}
      color={selected ? "violet" : "grey-4"}
      label={skill.name}
      aria-checked={!!selected}
      sx={{
        "&:hover": {
          border: "1px solid var(--medium-violet)",
          color: "var(--black)",
          backgroundColor: "var(--soft-violet)",
        },
      }}
    />
  );
};
